import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import { QueryProvider } from './context/QueryContext';
import { ProvideAuth, useAuth } from './context/AuthContext';
import SigninScreen from './screens/SigninScreen';
import AboutScreen from './screens/AboutScreen';
import ImportScreen from './screens/ImportScreen';
import BarcodeScreen from './screens/BarcodeScreen';
import UserEditScreen from './screens/user/UserEdit';
import Amplify from 'aws-amplify';
import AwsExports from './common/AwsExports.js';
import PrivateRoute from './routeUtilities/PrivateRoute';
import PropertyEditScreen from './screens/property/PropertyEdit';
import EquipmentEditScreen from './screens/equipment/EquipmentEdit';
import StartScreen from './screens/StartScreen';
import DSTAppInBrowserScreen from './screens/DSTAppInBrowserScreen';
import UsersScreen from './screens/UsersScreen';
import InspectionsScreen from './screens/InspectionsScreen';
import AnalyticsScreen from './screens/AnalyticsScreen';
import MigrationScreen from './screens/MigrationScreen';
import MetabaseScreen from './screens/MetabaseScreen';
import AnalyticsCountScreen from './screens/AnalyticsCountScreen'
import SoundDatabaseScreen from './screens/SoundDatabaseScreen'

import PropertiesScreen from './screens/PropertiesScreen'
import ReportsScreen from './screens/ReportsScreen';
import MetricsScreen from './screens/MetricsScreen';
import WorkOrdersScreen from './screens/WorkOrdersScreen';
import CostAvoidanceScreen from './screens/CostAvoidanceScreen';
import CostAvoidanceMetricsScreen from './screens/CostAvoidanceMetricsScreen';
import CompanyActivityReport from './screens/CompanyActivityReport';
import CompanyAdminDashboard from './screens/CompanyAdminDashboard';
import CompanySettingsScreen from './screens/CompanySettingsScreen';
import NotificationsScreen from './screens/NotificationsScreen';
import LandingPageResolver from './screens/LandingPageResolver';
import { ToastContainer } from 'react-toastify';
import {TopNavBar} from './screens/components/TopNavBar';
import TaskingSheetScreen from './screens/TaskingSheetScreen';
import PropertyListScreen from './screens/PropertyListScreen';
import { ProvideFilterContext, useFilterContext } from "./context/SharedFilterContext";
import { MikeProvider } from "./context/MikeContext";
import { NotificationsProvider } from './context/NotificationsContext';
import ChatWidget from './screens/components/ChatWidget';
import 'bootstrap/dist/css/bootstrap.min.css';


Amplify.configure(AwsExports);

// Hide debug logging in production.
//
// This used to test only for web.dstapp.com - but that host 301-redirects to
// dstportal.com, so users are never on it and the check never fired. Logging was live in
// production the whole time. Matching on hostname (not href) against both production hosts
// fixes that; web-alpha / web-beta and localhost stay verbose for debugging.
const PRODUCTION_HOSTS = ["dstportal.com", "www.dstportal.com", "web.dstapp.com"];
if (PRODUCTION_HOSTS.includes(window.location.hostname)) {
  console.log = () => {}
}

function App() {
  return (
    <QueryProvider>
      <ProvideAuth>
        <NotificationsProvider>
        <ProvideFilterContext>
          <MikeProvider>
            <Router>
            <ToastContainer
              autoClose={20000}
              limit={5}
              position={"bottom-right"}
              newestOnTop
              closeOnClick
              draggable
            />
            <div className="d-flex flex-column container-fluid p-0 m-0" style={{minHeight: "100vh", backgroundColor: "#e6e6e6"}}>
              <TopNavBar/>

              {/* Routes match BEGINNING of URL, order matters!*/}
              <Switch>
                <Route path="/auth">
                  <SigninScreen />
                </Route> 
                {/* <PrivateRoute path="/propertySelect">
                  <PropertiesPickerScreen />
                </PrivateRoute> */}
                <PrivateRoute path="/start">
                  <CompanyActivityReport />
                </PrivateRoute>
                <PrivateRoute path="/user/edit/:uuid">
                  <UserEditScreen></UserEditScreen>
                </PrivateRoute>
                <PrivateRoute path="/user/new">
                  <UserEditScreen></UserEditScreen>
                </PrivateRoute>
                <PrivateRoute path="/property/edit/:uuid">
                  <PropertyEditScreen></PropertyEditScreen>
                </PrivateRoute>
                <PrivateRoute path="/property/edit/">
                  <PropertyEditScreen></PropertyEditScreen>
                </PrivateRoute>
                <PrivateRoute path="/equipment/edit/:uuid">
                  <EquipmentEditScreen></EquipmentEditScreen>
                </PrivateRoute>
                <Route path="/generate-barcode">
                  <BarcodeScreen />
                </Route>
                <PrivateRoute path="/about">
                  <AboutScreen />
                </PrivateRoute>
                <PrivateRoute path="/import">
                  <ImportScreen />
                </PrivateRoute>
                <PrivateRoute path="/users">
                  <UsersScreen />
                </PrivateRoute>
                <Route path="/reports">
                  <ReportsScreen />
                </Route>
                <PrivateRoute path="/properties">
                  <PropertiesScreen />
                </PrivateRoute>
                <PrivateRoute path="/tasking-sheets">
                  <TaskingSheetScreen/>
                </PrivateRoute>
                <PrivateRoute path="/inspections">
                  <InspectionsScreen />
                </PrivateRoute>
                <PrivateRoute path="/analytics">
                  <AnalyticsScreen />
                </PrivateRoute>
                <PrivateRoute path="/migration">
                  <MigrationScreen />
                </PrivateRoute>

                <PrivateRoute path="/metabase_screen">
                  <MetabaseScreen />
                </PrivateRoute>

                <PrivateRoute path="/metrics_screen">
                  <MetricsScreen />
                </PrivateRoute>

                <PrivateRoute path="/work_orders_screen">
                  <WorkOrdersScreen/>
                </PrivateRoute>
                <PrivateRoute path="/company_settings">
                  <CompanySettingsScreen />
                </PrivateRoute>

                <PrivateRoute path="/notifications_screen">
                  <NotificationsScreen />
                </PrivateRoute>

                <PrivateRoute path="/property_lists">
                  <PropertyListScreen />
                </PrivateRoute>

                <PrivateRoute path="/cost_avoidance_screen">
                  <CostAvoidanceScreen />
                </PrivateRoute>

                <PrivateRoute path="/cost_avoidance_metrics_screen">
                  <CostAvoidanceMetricsScreen />
                </PrivateRoute>

                <PrivateRoute path="/company_activity_report">
                  <CompanyActivityReport />
                </PrivateRoute>

                <PrivateRoute path="/company_admin_dashboard">
                  <CompanyAdminDashboard />
                </PrivateRoute>


                <PrivateRoute path="/analytics_count_screen">
                  <AnalyticsCountScreen />
                </PrivateRoute>


                <PrivateRoute path="/sound_database_screen">
                  <SoundDatabaseScreen />
                </PrivateRoute>

                <PrivateRoute path="/dstapp">
                  <DSTAppInBrowserScreen/>
                </PrivateRoute>
                <PrivateRoute path="/">
                  {/* <StartScreen /> */}
                  {/* Role-based landing page routing */}
                  <LandingPageResolver />
                </PrivateRoute>
              </Switch>

              <footer className="footer mt-auto">
                  <div className="d-flex flex-row justify-content-end">
                    <img
                      src="/19286M1a_PowBy_DST_LogoColor.png"
                      style={{height: 50}}
                      className="m-2"
                    />
                  </div>
              </footer>

            </div>

            {/* Global Mike AI Assistant - Available on all pages for Meijer */}
            <ChatWidget />
          </Router>
        </MikeProvider>
        </ProvideFilterContext>
        </NotificationsProvider>
      </ProvideAuth>
    </QueryProvider>
  );
}

export default App;
